import React from 'react'
import { getStorageValue, StorageFieldDefaults, StorageFields } from '../../../storage/browserStorage'

/**
 * @param cardId: String
 * @param size: String = "hand" | "trick"
 */
class Card extends React.Component
{

    getCardImageURL(cardId, cardStyle)
    {
        let url = "/assets/images/cards/" + cardId.toLowerCase()

        if (cardStyle === "alt" && cardId.match("QUEEN|KING|JACK|^PIGLET"))
        {
            url += "_alt"
        }

        return url + ".png"
    }

    render()
    {
        let className = "game-card " + this.props.size + " " + (this.props.className || "")
        if (this.props.cardId === "SUPER_PIGLET") {
            className += " super-piglet"
        }

        return (
            <img 
                draggable="false"
                src={ this.getCardImageURL(this.props.cardId, getStorageValue(StorageFields.CARD_STYLE)) }
                onClick={ this.props.onClick } 
                onMouseEnter={ this.props.onMouseEnter }
                onMouseLeave={ this.props.onMouseLeave }
                style={{ display: "flex", alignItems: "center", justifyContent: "center", ...(this.props.style || {}) }} 
                className={ className }>
                
            </img>
        )
    }

}

function getCardDimensions(parentWidth, parentHeight)
{
    const cardWidth = Math.min(270, Math.min(parentWidth / 10, parentHeight / 5))
    const cardHeight = cardWidth / 0.6483516484
    return {
        width: cardWidth,
        height: cardHeight
    }
}

export default Card
export { Card, getCardDimensions }